import styled, { keyframes } from "styled-components";

const spCircRot = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
`;

const SpinnerWrap = styled.div`
  display: flex;
  align-items: center;
`;

const SpinnerMain = styled.div`
  width: 32px;
  height: 32px;
  clear: both;
  margin: 4px auto;

  border: 4px var(--blue15) solid;
  border-top: 4px var(--blue) solid;
  border-radius: 50%;
  -webkit-animation: ${spCircRot} 0.6s infinite linear;
  animation: ${spCircRot} 0.6s infinite linear;
`;

export interface SpinnerProps {
  className?: string;
  size?: string;
  width?: string;
  backColor?: string;
  frontColor?: string;
}

const Spinner = (props: SpinnerProps) => (
  <SpinnerWrap className={props.className} aria-busy="true" aria-live="polite">
    <SpinnerMain
      style={{
        width: props.size || "32px",
        height: props.size || "32px",
        borderWidth: props.width || "4px",
        borderLeftColor: props.backColor || "var(--blue15)",
        borderRightColor: props.backColor || "var(--blue15)",
        borderBottomColor: props.backColor || "var(--blue15)",
        borderTopColor: props.frontColor || "var(--blue)",
      }}
    />
  </SpinnerWrap>
);

export default Spinner;
